import { Button, Input, message } from 'antd';
import { DeleteAccount, InitiateOTPAccountDeletion } from '@/services/auth.api';
import React, { useState } from 'react';

import Modal from '../global/Modal';
import { flashError } from '@/utils/helpers';
import { logout } from '@/redux/slices/auth.slice';
import { useAppSelector } from '@/redux/hooks';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/navigation';
import { verifyOtp } from '../../services/auth.api';

interface DeleteAccountModalProps {
    visible: boolean;
    onClose: () => void;
    onDelete: () => void;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({ visible, onClose, onDelete }) => {
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const { user } = useAppSelector((state: any) => state.auth);
    const router = useRouter();
    const dispatch = useDispatch();

    const sendOtp = async () => {
        try {
            const result = await InitiateOTPAccountDeletion();
            if (result)
                message.success('OTP sent to your registered email and phone.');
            setIsOtpSent(true);
        } catch (error) {
            flashError(error);
            setIsOtpSent(false);
        }

    };

    const verifyOtpfromAPI = async () => {
        try {
            const result = await verifyOtp({
                emailOrPhone: user.email,
                otp
            })
            if (result && result.user == user) {
                setIsOtpVerified(true);
                message.success('OTP verified successfully. Proceed to Delete Your Account.');
            }
        } catch (error) {
            flashError(error);
        }
        /* if (otp === '123456') {
            setIsOtpVerified(true);
            message.success('OTP verified successfully.');
        } else {
            message.error('Invalid OTP. Please try again.');
        } */
    };

    const handleDelete = async () => {
        if (isOtpVerified) {
            try {
                const deleted = await DeleteAccount();
                if (deleted) {
                    onDelete();
                    onClose();
                    message.success('Account deleted successfully.');
                    dispatch(logout());
                    router.replace("/")
                }
            } catch (error) {
                flashError(error);
                router.refresh();
            }
        } else {
            message.error('Please verify OTP before deleting the account.');
            router.refresh();
        }
    };

    return (
        <Modal
            modalTitle="Delete Account"
            openModal={visible}
            closeModal={onClose}
        >
            <p>Deleting Your Account is an irreversible action. An OTP would be sent to your registered email and phone number to delete your account.</p>
            <Input
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                disabled={!isOtpSent || isOtpVerified}
            />
            <Button key="cancel" onClick={onClose}>
                Cancel
            </Button>
            <Button key="sendOtp" type="primary" className='bg-crunchies-red' onClick={sendOtp} disabled={isOtpSent}>
                Send OTP
            </Button>
            <Button key="verifyOtp" type="primary" className='bg-crunchies-red' onClick={verifyOtpfromAPI} disabled={!isOtpSent || isOtpVerified}>
                Verify OTP
            </Button>
            <Button key="delete" type="primary" className='bg-crunchies-red' danger onClick={handleDelete} disabled={!isOtpVerified}>
                Delete Account
            </Button>
        </Modal>
    );
};

export default DeleteAccountModal;